/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateAPIKeyForIntegratorUserOptions,
  CreateAPIKeyForIntegratorUserResponses,
} from '../types/CreateAPIKeyForIntegratorUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create apikey for a user
 * {@link /v1/user/:user_id/apikey}
 */
export function createAPIKeyForIntegratorUser<ThrowOnError extends boolean = true>(
  options: Options<CreateAPIKeyForIntegratorUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateAPIKeyForIntegratorUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user/{user_id}/apikey',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateAPIKeyForIntegratorUserResponses, ThrowOnError>>,
  )
}
